import React from 'react'
import { Loading } from '@myxplor/ui'
import { FormDisplayErrors, FormInputWrapper } from '@myxplor/forms'
import FormSelect from 'react-select'
import LocalAsyncStore from '../../../local-async-store'
import './styles.css'

const apiEndPoint = ({ apiEndPoint }) => apiEndPoint

export const customValue = args =>
  Array.isArray(args) ? args.map(({ value }) => value) : args.value

export const TypeAheadSelect = props => (
  <FormInputWrapper {...props}>
    <FormSelect
      {...props.selectProps || {}}
      className="myxplor__type-ahead"
      id={props.name}
      {...(props.valueFilter ? {value: props.valueFilter(props.options)} : {})}
      onChange={args => props.onChange(props.name, customValue(args))}
      options={props.options}
      placeholder={props.placeholder || 'Please select...'}
    />
  </FormInputWrapper>
)

export const RemoteTypeAheadSelect = props => {
  const { loading, data } = props.options

  if (!data || loading) return <Loading>Loading {props.label}</Loading>
  if (data.length === 0) return <FormDisplayErrors errors={`No matching ${props.label}`} />

  return (
    <TypeAheadSelect {...props} options={props.optionsFilter ? props.optionsFilter(data) : data} />
  )
}

export default LocalAsyncStore('options', RemoteTypeAheadSelect, apiEndPoint)



// WEBPACK FOOTER //
// ./src/ui/forms/type-ahead/index.jsx